module.exports = __webpack_public_path__ + "img/soft_5.0aa617e1.png";